import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import classnames from "classnames";
import RegentInfo from "../components/regencia/RegentInfo.jsx";

class Regencia extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    previa: false,
    previa_url: "",
    modalOpen: false,
    working: true,
    workingModal: true,
    toggle: false,
    paginaActual: 0,
    paginas: 0,
    registros: 0,
    activeTab: "1",
    buscar: {},
    regente: {
      id: "",
      folio_regente: "",
      numero_identificacion: "",
      codigo_ipsa: "",
      nombres: "",
      apellido_paterno: "",
      apellido_materno: "",
      correo_electronico: "",
      telefono_convencional: "",
      telefono_celular: "",
      direccion: "",
      departamento: "",
      municipio: "",
      profesiones: [],
    },
    regentes: [],
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.resetStates = this.resetStates.bind(this);
    this.handleCloseBtn = this.handleCloseBtn.bind(this);
    this.getAllRegentsByRegent = this.getAllRegentsByRegent.bind(this);
    this.handleRegentesPage = this.handleRegentesPage.bind(this);
    this.handlemodalRegentInfo = this.handlemodalRegentInfo.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.getAllRegentsByRegent(1);
  }

  //Funcion para cambiar de pagina en el grid de regente
  getAllRegentsByRegent(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getAllRegentsByRegent?page=" + page + src).then((r) => {
      if (r) {
        this.setState({
          regentes: r.data,
          paginas: r.last_page,
          registros: r.total,
          paginaActual: r.current_page,
          workingGrid: false,
        });
      }
    });
  }

  handlemodalRegentInfo(e) {
    Api.loading(true);
    Api.fetch("app/getRegentData?id=" + e.target.id+"&tipo_id="+e.target.attributes.tipo_id.value).then((data) => {
      this.setState({ regente: data, workingModal: false, modalOpen: true });
      Api.loading(false);
    });
  }

  handleRegentesPage(e) {
    this.getAllRegentsByRegent(e.target.value);
  }

  resetStates() {
    this.setState({
      modalOpen: this.initialState.modalOpen,
      workingModal: this.initialState.workingModal,
      regente: this.initialState.regente,
    });
  }

  handleCloseBtn(evt) {
    this.setState({ previa: false });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/regencia">Información regente</Link>
          </li>
        </ol>
        <h1 className="page-header">Información regente</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    REGENTES
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    REGENTES
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">FOLIO REGENTE</th>
                        <th className="text-center">NOMBRE</th>
                        <th className="text-center">TIPO REGENTE</th>
                        <th className="text-center">ESTATUS LICENCIA</th>
                        <th className="text-center">VENCIMIENTO LICENCIA</th>
                        <th className="text-center" width="10%"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.regentes && this.state.regentes.length > 0 ? (
                        this.state.regentes.map((r, index) => (
                          <tr
                            key={index}
                            className={
                              r.estatus === "En espera" ? "alerta" : ""
                            }
                          >
                            <td className="text-center">{r.folio_regente}</td>
                            <td className="text-center">{r.nombre}</td>
                            <td className="text-center">{r.tipo_regente}</td>
                            <td className="text-center">
                              {r.estatus_licencia}
                            </td>
                            <td className="text-center">
                              {r.vencimiento_licencia}
                            </td>
                            <td className="text-center">
                              <button
                                onClick={this.handlemodalRegentInfo}
                                id={r.id}
                                tipo_id ={r.tipo_regente_id}
                                className="btn bg-gradient-blue"
                                hidden={r.rel_reg_tipo_status === "0"? true : false}
                              >
                                <i id={r.id} tipo_id ={r.tipo_regente_id} className="fas fa-folder-open"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            <b>No se encontraron registros</b>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getAllRegentsByRegent(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.getAllRegentsByRegent(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.getAllRegentsByRegent(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getAllRegentsByRegent(this.state.paginas);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleRegentesPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
          <Modal
            isOpen={this.state.modalOpen}
            tabIndex="-1"
            style={{
              maxWidth: "100%",
              width: "80%",
            }}
          >
            <ModalHeader
              width="100%"
              toggle={() => {
                this.resetStates();
              }}
              className="text-center"
            >
              INFORMACIÓN DE REGENTE
            </ModalHeader>
            <ModalBody>
              <RegentInfo
                regente={this.state.regente}
                workingModal={this.state.workingModal}
              />
            </ModalBody>
            <ModalFooter>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <button
                      onClick={this.resetStates}
                      className="btn btn-danger float-right"
                    >
                      Regresar
                    </button>
                  </div>
                </div>
              </div>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    );
  }
}

export default Regencia;
